import { styled } from '@mui/system'
import CustomerSidebar from '../../organisms/customer/layout/customer-sidebar'

export const Root = styled('div')`
	display: flex;
	flex-direction: column;
	height: 100%;
`

export const Container = styled('div')`
	flex: 1;
	display: flex;
	padding: ${({ theme }) => theme.spacing(4, 3, 3)};
	align-items: flex-start;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacing(3)};
	${({ theme }) => theme.breakpoints.up('md')} {
		flex-direction: row;
		padding: ${({ theme }) => theme.spacing(5)};
		background-color: ${({ theme }) => theme.palette.grey.lighter};
		gap: ${({ theme }) => theme.spacing(2.5)};
	}
`

export const CustomerCareSidebar = styled(CustomerSidebar)`
	border: 1px solid ${({ theme }) => theme.palette.grey.light};
	padding: ${({ theme }) => theme.spacing(3)};
	margin-top: ${({ theme }) => theme.spacing(3)};
	${({ theme }) => theme.breakpoints.up('md')} {
		border-color: ${({ theme }) => theme.palette.background.paper};
		padding: ${({ theme }) => theme.spacing(5, 4)};
		margin-top: 0;
	}
`

export const LeftColumn = styled('div')`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacing(2.5)};
`

export const SubContainer = styled('div')`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	width: 100%;
	order: 1;
	overflow: hidden;
	background-color: ${({ theme }) => theme.palette.background.paper};
	${({ theme }) => theme.breakpoints.up('md')} {
		padding: ${({ theme }) => theme.spacing(5)};
	}
`
